import { Trans } from "next-i18next";
import { useLoyaltyTierCopy } from "../../../../services/hooks/loyalty/useLoyaltyTierCopy";
import { useAppSelector } from "../../../../services/hooks/useReduxHooks";
import { useTranslationI18 } from "../../../../services/hooks/useTranslationI18";
import { localizedNumber } from "../../../../utils/help/localization/localization";
import { WarningCircleIcon } from "../../../global/Icons/loyalty.icons";
import styles from "./LoyaltyPointsExpiryBanner.module.scss";

export const LoyaltyPointsExpiryBanner = () => {
  const { i18n } = useTranslationI18();
  const { getPointLabel } = useLoyaltyTierCopy();
  const pointsExpiry = useAppSelector(
    (state) => state.loyaltyCustomerInfo.data?.pointsExpiry
  );

  if (!pointsExpiry?.amount || !pointsExpiry.expiresAt) {
    return null;
  }

  const expiresAt = new Date(pointsExpiry.expiresAt);

  if (Number.isNaN(expiresAt.getTime())) {
    return null;
  }

  const now = new Date();

  // ----------------------Nothing due this month means no strip at all-----------------------
  if (
    expiresAt.getFullYear() !== now.getFullYear() ||
    expiresAt.getMonth() !== now.getMonth()
  ) {
    return null;
  }

  return (
    <div className={styles.expiry_banner} data-testid="points-expiry-banner">
      <p>
        <WarningCircleIcon />
        <span>
          <Trans
            i18nKey="pointing-system:points-expiring-by"
            components={{ b: <b /> }}
            values={{
              count: localizedNumber(pointsExpiry.amount),
              points: getPointLabel(pointsExpiry.amount),
              date: expiresAt.toLocaleDateString(i18n.language, {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              }),
            }}
          />
        </span>
      </p>
    </div>
  );
};
